/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Admin.Search <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 13.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 13.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.ExportArchiveEmail", $.common.VisualBase, {

    _create: function () {
        var me = this;
        try {
          
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 320;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
          
            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);
        

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            var startParam = JSON.parse(me.specific.startParameters);

           var htmlSelectSignals = me.element.find(".select-signals").clone();
          
            
           me.fnd(".select-signals").replaceWith(
               $("<div>", { "class": "select-signals-box vc-grid-2col  vc-grid-margin-right" })
           );
           me.fnd(".select-signals-box").vcOptionBox({
               caption: me.specific.resources.selection,
               items: [{ button: me.specific.resources.signals_lbl, clickable: false, isList: true, content: htmlSelectSignals.clone() }]
           });


           var htmlSelectDataType = me.element.find(".select-datatype").clone();

           me.fnd(".select-datatype").replaceWith(
               $("<div>", { "class": "select-datatype-box vc-grid-2col " })
           );
           me.fnd(".select-datatype-box").vcOptionBox({
               caption: me.specific.resources.selection,
               items: [{ button: me.specific.resources.datatype_lbl, clickable: false, isList: true, content: htmlSelectDataType.clone() }]
           });

           var htmlOptions = me.element.find("#div-options").clone();

           me.fnd("#div-options").replaceWith(
               $("<div>", { "class": "select-options-box vc-grid-2col " })
           );
            me.fnd(".select-options-box").vcOptionBox({
               caption: me.specific.resources.selection,
                items: [{ button: me.specific.resources.options_lbl, clickable: false, isList: false, content: htmlOptions.clone() }]
           });

           //me.resources.signals_lbl
           me.fnd(".vc-date-box").addClass("vc-grid-margin-bottom").vcDateBox({
               mode: "Range",
               align: "right",
               defaultRange: { from: moment(startParam.StartDate, "DD.MM.YYYY"), to: moment(startParam.EndDate, "DD.MM.YYYY") },
               interval: 1,
               langID: me.settings.userLangIDForCulture,
               callback: function () { }
           });


            me.element.on("click", "#btn-export", function () {
                me._export();
            });
            me.fnd("#btn-export").button();


            me.fnd(".select-datatype-box .ddl").val(startParam.DataType);
            if (startParam.Overwrite)  me.fnd("#div-options #chk-overwrite").prop("checked", "checked");
            if (startParam.AddZst) me.fnd("#div-options #chk-add-zst").prop("checked", "checked");


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _export: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        var param;
        try {
          
            param = {};
            param.Bsaid = parseInt(me.fnd(".select-signals-box .ddl").val());
            param.DataType = parseInt(me.fnd(".select-datatype-box .ddl").val());
            param.Overwrite = me.fnd(".select-options-box #chk-overwrite").prop("checked");
            param.AddZst = me.fnd(".select-options-box #chk-add-zst").prop("checked");

            var dateRange = me.element.find(".vc-date").vcDate("getDate");
            param.StartDate = moment(dateRange.from, "DD.MM.YYYY").format("DD.MM.YYYY");
            param.EndDate = moment(dateRange.to, "DD.MM.YYYY").format("DD.MM.YYYY");
        
            me.fnd("#div-link").html(me.getLoadingIcon());

           me.exportData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }
               if (result.Valid === false) {
                   me.fnd("#div-link").html(result.ErrorMsg).addClass("error");
                
                   return true;
               }
                me.fnd("#div-link").removeClass("error").html($("<a>").attr("href", result.Url).html(me.specific.resources.export_lbl + ".xlsx"));
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },




    specificInfoHandling: function (bError) {
        var me = this;
        try {
            //if (bError) {
            //    me.fnd(".lst-entries, #div-top-menu, #div-filter-menu").hide();
            //}
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});

